import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const AdminDashboard = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const localApplications = JSON.parse(localStorage.getItem('applications')) || [];
    localApplications.sort((a, b) => new Date(b.submissionDate) - new Date(a.submissionDate));
    setApplications(localApplications);
    setLoading(false);
  }, []);

  const handleStatusUpdate = (serialNumber, newStatus) => {
    const updatedApplications = applications.map(app => {
      if (app.serialNumber === serialNumber) {
        // Add approvalDate when status is set to 'approved'
        return { 
          ...app, 
          status: newStatus,
          ...(newStatus === 'approved' && { approvalDate: new Date().toISOString() })
        };
      }
      return app;
    });
    setApplications(updatedApplications);
    localStorage.setItem('applications', JSON.stringify(updatedApplications));
  };

  if (loading) {
    return <div className="text-center py-10">Loading applications...</div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6 text-gray-800">Admin Dashboard</h1>
      <p className="mb-8 text-gray-600">Total Applications: {applications.length}</p>

      <div className="bg-white shadow-md rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full leading-normal">
            <thead>
              <tr className="bg-gray-100 text-left text-gray-600 uppercase text-sm">
                <th className="px-5 py-3 border-b-2 border-gray-200">Serial No.</th>
                <th className="px-5 py-3 border-b-2 border-gray-200">Applicant Name</th>
                <th className="px-5 py-3 border-b-2 border-gray-200">Certificate Type</th>
                <th className="px-5 py-3 border-b-2 border-gray-200">Submission Date</th>
                <th className="px-5 py-3 border-b-2 border-gray-200">Status</th>
                <th className="px-5 py-3 border-b-2 border-gray-200">Actions</th>
              </tr>
            </thead>
            <tbody>
              {applications.length > 0 ? (
                applications.map(app => (
                  <tr key={app.serialNumber} className="border-b border-gray-200 hover:bg-gray-50">
                    <td className="px-5 py-5 text-sm">{app.serialNumber}</td>
                    <td className="px-5 py-5 text-sm">{app.name_en}</td>
                    <td className="px-5 py-5 text-sm">{app.formType}</td>
                    <td className="px-5 py-5 text-sm">{new Date(app.submissionDate).toLocaleDateString()}</td>
                    <td className="px-5 py-5 text-sm">
                      <span className={`px-2 py-1 font-semibold leading-tight rounded-full text-xs ${
                        app.status === 'pending' ? 'bg-yellow-200 text-yellow-900' :
                        app.status === 'approved' ? 'bg-green-200 text-green-900' : 'bg-red-200 text-red-900'
                      }`}>
                        {app.status}
                      </span>
                    </td>
                    <td className="px-5 py-5 text-sm space-x-2">
                      {app.status === 'pending' && (
                        <>
                          <button 
                            onClick={() => handleStatusUpdate(app.serialNumber, 'approved')}
                            className="text-white bg-green-500 hover:bg-green-600 px-3 py-1 rounded-md text-xs font-bold transition-colors"
                          >
                            Approve
                          </button>
                          <button 
                            onClick={() => handleStatusUpdate(app.serialNumber, 'rejected')}
                            className="text-white bg-red-500 hover:bg-red-600 px-3 py-1 rounded-md text-xs font-bold transition-colors"
                          >
                            Reject
                          </button>
                        </>
                      )}
                      {app.status === 'approved' && (
                        <Link to={`/certificate/${app.serialNumber}`} target="_blank" className="text-white bg-blue-500 hover:bg-blue-600 px-3 py-1 rounded-md text-xs font-bold">
                           Generate Certificate
                        </Link>
                      )}
                       {app.status === 'rejected' && (
                        <span className="text-gray-500 text-xs">Rejected</span>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-10 text-gray-500">No applications found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
